"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const sizeMap = {
    xxs: '12px',
    xs: '14px',
    sm: '16px',
    md: '18px',
    lg: '20px',
    xl: '24px',
    xxl: '28px',
};
const weightMap = {
    regular: 400,
    semibold: 500,
    bold: 600,
    extrabold: 700,
};
const Base = ({ size = 'md', weight = 'regular', children, ...props }) => {
    return (react_1.default.createElement(react_2.Text, { fontSize: sizeMap[size], fontWeight: weightMap[weight], ...props }, children));
};
exports.Base = Base;
